import { Box, useTheme } from '@mui/material';
import { memo } from 'react';
// @mui

// ----------------------------------------------------------------------
type PropsTypes = {
  color?: string;
};

const Ellipsis = ({ color }: PropsTypes) => {
  const theme = useTheme();

  return (
    <Box display="flex" alignItems="center" justifyContent="center" data-testid="ellipsis">
      <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.375 10H4.38375M10.5 10H10.5088M16.625 10H16.6338M5.25 10C5.25 10.4832 4.85825 10.875 4.375 10.875C3.89175 10.875 3.5 10.4832 3.5 10C3.5 9.51675 3.89175 9.125 4.375 9.125C4.85825 9.125 5.25 9.51675 5.25 10ZM11.375 10C11.375 10.4832 10.9832 10.875 10.5 10.875C10.0168 10.875 9.625 10.4832 9.625 10C9.625 9.51675 10.0168 9.125 10.5 9.125C10.9832 9.125 11.375 9.51675 11.375 10ZM17.5 10C17.5 10.4832 17.1082 10.875 16.625 10.875C16.1418 10.875 15.75 10.4832 15.75 10C15.75 9.51675 16.1418 9.125 16.625 9.125C17.1082 9.125 17.5 9.51675 17.5 10Z"
          stroke={color ?? theme.palette.secondary.darker}
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  );
};

export default memo(Ellipsis);
